module.exports = __webpack_public_path__ + "static/media/rss.ae8379a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/rss.png
// module id = 1191
// module chunks = 110